export default {
  page: "Women"
};
